<form novalidate (ngSubmit)="save()" #formClientInfo="ngForm">
    <div class="card-body mt-5">
        <div class="row">
            <div class="col-lg-2 mb-lg-0 mb-5 form-group">
                <label>Rabies Tag:</label>
                <input type="text" class="form-control" name="_rabie_tag_no" autocomplete="off" required
                    [(ngModel)]="petService.pet_tag.rabie_tag_no" />
            </div>
            <div class="col-lg-2 mb-lg-0 mb-5 form-group">
                <label>ID Chip No:</label>
                <input type="text" class="form-control" name="_chip_no" autocomplete="off" disabled
                    [(ngModel)]="petService.pet_tag.chip_no" />
            </div>
            <div class="col-lg-2 mb-lg-0 mb-5 form-group">
                <label>Body Condition:</label>
                <input type="text" class="form-control" name="_enviroment_1" autocomplete="off" disabled
                    [(ngModel)]="this.petService.pet_environment.combo_index0" />
            </div>
            <div class="col-lg-2 mb-lg-0 mb-5 form-group">
                <label>License No:</label>
                <input type="text" class="form-control" name="_license_no" autocomplete="off" disabled
                    [(ngModel)]="petService.pet_tag.license_no" />
            </div>
            <div class="col-lg-2 mb-lg-0 mb-5 form-group">
                <label>Living Enviroment:</label>
                <input type="text" class="form-control" name="_enviroment_2" autocomplete="off" disabled
                    [(ngModel)]="this.petService.pet_environment.combo_index1" />
            </div>
            <div class="col-lg-2 mb-lg-0 mb-5 form-group">
                <label>Lifestyle:</label>
                <input type="text" class="form-control" name="_enviroment_3" autocomplete="off" disabled
                    [(ngModel)]="this.petService.pet_environment.combo_index2" />
            </div>
        </div> 
        
        <div class="row d-flex justify-content-end mt-5"> 
                <div class="dropdown">
                    <button type="button" class="btn btn-sm btn-info mr-3" data-toggle="dropdown"
                        aria-expanded="false">
                        <i class="fas fa-plus icon-sm"></i>  Physical Profile
                    </button>
                    <div class="dropdown-menu">
                        <a class="dropdown-item" (click)="add(item)" *ngFor="let item of profile_types_invisible">
                            {{ item.profile_type }}
                        </a>
                    </div>
                </div>
                <button type="button" class="btn btn-sm btn-info mr-3" (click)="openLabTestModal()">
                    <i class="fas fa-plus icon-sm"></i> Lab Test
                </button> 

            <div class="col-lg-12 my-5 separator separator-dashed"></div>
        </div>
        <div class="row">
            <div class="col-md-6 mb-3" *ngFor="let table of profile_types_visible; let i = index">
                <div class="card">
                    <h5 class="card-header"> {{ table.profile_type }}</h5>
                    <div class="card-body">
                        <div class="table-responsive">
                            <table class="table table-sm table-striped">
                                <thead>
                                    <tr>
                                        <th>
                                            {{ table.profile_type }}
                                        </th>
                                        <th>
                                            Date
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let item of petService[table.list]">
                                        <td>
                                            {{ item.profile }}
                                        </td>
                                        <td>
                                            {{ item.profile_date }}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
        
                        <div echarts [options]="table.options" class="demo-chart"></div> 
                    </div>
                </div> 
            </div>

            <div class="col-md-6 mb-3" *ngFor="let table of labtest_types_visible; let i = index">
                <div class="card" *ngIf="getTableLabtest(table.test_code).length >= 1">
                    <h5 class="card-header d-flex align-items-center">{{ table.test_desc }}</h5>
                    <div class="card-body">
                        <div class="table-responsive" >
                            <table class="table table-sm table-striped">
                                <thead>
                                    <tr>
                                        <th>
                                            Lab Test: {{ table.test_desc }}
                                        </th> 
                                        <th>
                                            Date
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let item of getTableLabtest(table.test_code)">
                                        <td>
                                            {{ item.labtest_val }} {{table.unit}}
                                        </td> 
                                        <td>
                                            {{ item.labtest_date }}     
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
        
                        <div echarts [options]="table.options" class="demo-chart"></div>
                    </div>
                </div> 
            </div>
            <!-- <div class="col">
                <div class="table-responsive">
                    <table class="table table-sm table-striped">
                        <thead>
                            <tr>
                                <th>
                                    Temp.
                                </th>
                                <th>
                                    Date
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let item of petService.pet_profile_temp">
                                <td>
                                    {{ item.profile | number }}
                                </td>
                                <td>
                                    {{ item.profile_date }}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div> -->
            <div class="col-lg-12 my-5 separator separator-dashed"></div>
        </div>
        <!-- <div class="row">

            <div class="col-md-6">
                <div echarts [options]="options1" class="demo-chart"></div>
            </div>

            <div class="col-md-6">
                <div echarts [options]="options2" class="demo-chart"></div>
            </div>
        </div> -->
    </div>
    <div class="card-footer text-right py-5">

        <button type="submit" class="btn btn-primary" [disabled]="formClientInfo.invalid">
            Save Changes
        </button>
    </div>
</form>

<div class="modal fade" id="labTestModal" tabindex="-1" role="dialog" aria-labelledby="labTestModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-md modal-dialog-centered" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">Lab Test</h5>
                <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                
                <div class="row">
                    <div class="col-6">
                        <select class="form-control mb-2" [(ngModel)]="sel_labtest" (change)="onLabTestChange($event)">
                            <option value="" disabled selected>Select Lab Test</option>
                            <option *ngFor="let item of petService.lab_test" [value]="item">{{item}}</option> 
                        </select>
                    </div>
                    <div class="col-6">
                        <select class="form-control mb-2" [(ngModel)]="sel_labname" (change)="onLabNameChange($event)" *ngIf="sel_labtest && petService.lab_name.length > 0">
                            <option value="" disabled selected>Select Lab Name</option>
                            <option *ngFor="let item of petService.lab_name" [value]="item.seq_no">{{item.test_desc}}</option> 
                        </select> 
                    </div> 
                </div>

                <div class="col-lg-12 my-3 separator separator-dashed"></div>

                <div class="row">
                    <div class="col-6 my-1" *ngFor="let item of petService.load_test">
                        <div class="form-check">
                            <input class="form-check-input" type="checkbox" [value]="item.seq_no" [(ngModel)]="item.selected" [id]="'checkbox-' + item.seq_no" />
                            <label class="form-check-label" [for]="'checkbox-' + item.seq_no"> 
                                {{ item.test_desc }}
                            </label>
                        </div>
                    </div>
                </div>
                 
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button> 
                <button type="button" class="btn btn-primary" (click)="getLabtest()"><i class="las la-list-alt"></i> Select</button> 
            </div>
        </div>
    </div>
</div>